import Vue from 'vue'
import { UnleashClient } from 'unleash-proxy-client'

// Always same-origin: the real Unleash host is never hardcoded into client
// code, it's resolved via the /unleash reverse-proxy location (see
// vue.config.js for local dev, nginx.<env>.conf for deployed environments).
const unleashConfig = {
  url: `${window.location.origin}/unleash`,
  clientKey: process.env.VUE_APP_UNLEASH_CLIENT_KEY,
  refreshInterval: 15,
  appName: 'assessment-center-pwa',
}

const unleash = new UnleashClient({ ...unleashConfig })

// Single shared sync counter, read reactively by every component via the
// mixin. Each component tracking its own copy would only catch 'update'
// events fired after that specific component mounts, so a component
// mounted between refreshes could stay stuck reporting "not yet synced"
// (and fail open) indefinitely.
export const unleashState = Vue.observable({ updated: 0 })
unleash.on('update', () => {
  unleashState.updated++
})

unleash.start()

// A route guard runs before Unleash's first fetch, so isEnabled would be false for everyone.
// Timeout: 'ready' never fires offline; after it, cached or false (fail closed).
export const whenFlagsReady = (timeoutMs = 5000) =>
  new Promise((resolve) => {
    if (unleash.isReady()) return resolve()
    const timer = setTimeout(resolve, timeoutMs)
    unleash.once('ready', () => {
      clearTimeout(timer)
      resolve()
    })
  })

export default unleash
